"use strict";
exports.__esModule = true;
var currencies_1 = require("../../currencies");
var utils_1 = require("./utils");
var currency = (0, currencies_1.getCryptoCurrencyById)("filecoin");
function getDeviceTransactionConfig(input) {
    var fields = [];
    fields.push({
        type: "amount",
        label: "Value"
    });
    fields.push({
        type: "filecoin.gasLimit",
        label: "Gas Limit",
        value: input.transaction.gasLimit.toFixed()
    });
    fields.push({
        type: "filecoin.gasPremium",
        label: "Gas Premium",
        value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], input.transaction.gasPremium, {
            showCode: false,
            disableRounding: true
        })
    });
    fields.push({
        type: "filecoin.gasFeeCap",
        label: "Gas Fee Cap",
        value: (0, currencies_1.formatCurrencyUnit)(currency.units[0], input.transaction.gasFeeCap, {
            showCode: false,
            disableRounding: true
        })
    });
    fields.push({
        type: "filecoin.method",
        label: "Method",
        value: (0, utils_1.methodToString)(input.transaction.method)
    });
    return fields;
}
exports["default"] = getDeviceTransactionConfig;
//# sourceMappingURL=deviceTransactionConfig.js.map